export default __webpack_public_path__ + "static/survey-results-d6182cc5d6c71a83d6a4e7f109e8e896.png";